<template>
  <application-layout>
    <v-container>
      <h1 class="mb-4">Facilities Index</h1>
      <facility-list />
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import FacilityList from "@/components/FacilityList";

export default {
  components: {
    ApplicationLayout,
    FacilityList
  }
};

</script>
